import { createContext, useContext } from 'react';

import { action, computed, makeObservable, observable, set, toJS } from 'mobx';

import {
  Payment,
} from '../generated/graphql';

export class PaymentStore {
  constructor() {
    makeObservable(this, {
      setPayments: action,
      payments: observable,
      activeRefundPayment: observable,
      setActiveRefundPayment: action,
      filteredPayments: computed,
      filteredName: computed,
      filter: observable,
      setFilter: action,
      sortedBy: observable,
      setSortedBy: action,
      sortOrder: observable,
      setSortOrder: action,
    })
    };


  static _store: PaymentStore;

  static get store() {
    if (!this._store) {
      this._store = new this();
      window['payment_store'] = this._store;
    }

    return this._store;
  }

  payments: Payment[] = [];
  setPayments = (newPayments: Payment[]) => {
    this.payments = newPayments;
  };

  activeRefundPayment?: any;
  setActiveRefundPayment = (payment?: Payment) => {
    this.activeRefundPayment = payment;
  };

  filter: number = 0;
  setFilter = (filter: number) => {
    this.filter = filter;
  }

  sortedBy: string = 'created_at';
  setSortedBy = (sortedBy: string) => {
    this.sortedBy = sortedBy;
  }

  sortOrder: string = 'asc';
  setSortOrder = (sortOrder: string) => {
    this.sortOrder = sortOrder;
  }

  get filteredPayments() {

    let sortedPayments = this.payments;

    if (this.sortedBy === 'amount') {
      sortedPayments = sortedPayments.sort((a, b) => {
        return b.amount - a.amount;
      });
    }
    else if (this.sortedBy === 'id') {
      sortedPayments = sortedPayments.sort((a, b) => {
        return b.id - a.id;
      });
    }
    else if (this.sortedBy === 'person_name') {
      sortedPayments = sortedPayments.sort((a, b) => {
        if (a.person_name && b.person_name) {
          return a.person_name.localeCompare(b.person_name);
        }
        return 0;
      });
    }
    else if (this.sortedBy === 'type') {
      sortedPayments = sortedPayments.sort((a, b) => {
        if (a.type && b.type) {
          return a.type.localeCompare(b.type);
        }
        return 0;
      });
    }
    else if (this.sortedBy === 'status') {
      sortedPayments = sortedPayments.sort((a, b) => {
        if (a.status && b.status) {
          return a.status - b.status;
        }
        return 0;
      });
    }
    else if (this.sortedBy === 'modified') {
      sortedPayments = sortedPayments.sort((a, b) => {
        if (a.modified && b.modified) { 
          return a.modified.localeCompare(b.modified);
        }
        return 0;
      });
    }
    else if (this.sortedBy === 'number') {
      sortedPayments = sortedPayments.sort((a, b) => {
        if (a.number && b.number) {
          return a.number.localeCompare(b.number);
        }
        return 0;
      });
    }

    if (this.sortOrder === 'desc') {
      sortedPayments = sortedPayments.reverse();
    }


    if (this.filter === 0) {
      return sortedPayments;
    }

    return sortedPayments.filter((payment) => payment.person_id === this.filter);
  
}

  get filteredName() {
    if (this.filter === 0) {
      return null;
    }

    const payment = this.payments.find((payment) => payment.person_id === this.filter);
    if (payment) {
      return payment.person_name;
    }

    return 'Unknown';
  }

  
}
